import Button from '@material-ui/core/Button';
import React from 'react';
import * as PropTypes from 'prop-types';

DownloadButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

function DownloadButton(props) {
  const { disabled, onClick } = props;
  return (
    <Button
      variant="contained"
      disabled={disabled}
      fullWidth={true}
      color="primary"
      onClick={onClick}
      data-testid="download-button"
    >
      Unduh Faktur Pajak
    </Button>
  );
}

export default DownloadButton;
